import { useTranslation } from "react-i18next";
import { useStyles } from "./style";
import { BorderedText } from "./BorderedText";
import { RequestState } from "pages/signup/utils/useRequestState";


interface GetResendTextProps {
    state: RequestState<unknown>;
    email: {
        userEmail: string;
    };
}

export const GetResendText: React.FC<GetResendTextProps> = ({ state, email }) => {
    const { t } = useTranslation();
    const { reSended, bottomNullDiv } = useStyles();
    switch (state.type) {
        case 'REQUEST_SUCCESS':
            return (
                <BorderedText
                    text={t('signup.submitted.reSended.successState', email)}
                    className={reSended}
                />
            );

        case 'REQUEST_ERROR':
            return (
                <BorderedText className={reSended} text={state.error.message} />
            );
        case 'REQUEST_START':
            return (
                <BorderedText
                    className={reSended}
                    text={t('signup.submitted.reSended.loadingState')}
                />
            );
        default:
            return <div className={bottomNullDiv} />;
    }
};